import axios from '../axios.instance'

export default class TransportationService {
    async getTransportation(){
        try {
            const res = await axios.get('/transportation')
            return res.data;
        } catch (error) {
            return error.response.data
        }
    }

    async getTransportationById(id){
        try {
            const res = await axios.get('/transportation/'+id);
            return res.data;
        } catch (error) {
            return error.response.data
        }
    }

    async addTransportation(data) {
        try {
            if(data != ''){
                const res = await axios.post('/transportation', {data})
                return res.data;
            }
        } catch (error) {
            return error.response.data
        }
    }

    async updateTransportation(transportation_id, data){
        try {
            if(transportation_id != 0) {
                const res = await axios.put('/transportation/'+transportation_id, {data})
                return res.data;
            }
        } catch (error) {
            return error.response.data
        }
    }

    async deleteTransportation(transportation_id){
        try {
            if(transportation_id != 0) {
                const res = await axios.delete('/transportation/'+transportation_id)
                return res.data;
            }
        } catch (error) {
            return error.response.data
        }
    }

    async searchTransportation(data) {
        try {
            if(data != '') {
                const res = await axios.get('/transportation/search/', {params: {company_name: data}})
                return res.data;
            }
        } catch (error) {
            return error.response.data
        }
    }

    //USE TO GET Transportation Company Name IN CONTRACT UPDATE FORM
    async getTransportationCompanyName(id){
        try {
            const res = await axios.get('/transportation/getcompanyname', {params: { transportationid: id }});
            return res.data;
        } catch (error) {
            return error.response.data
        }
    }

    //TRANSPORTATION CONTRACT
    async getContract(transport_id) {
        try {
            const res = await axios.get('/transportationcontract/', {params: {transportationid: transport_id}})
            return res.data;
        } catch (error) {
            return error.response.data
        }
    }

    async addTransportationContract(data) {
        try {
            if(data != ''){
                const res = await axios.post('/transportationcontract/add', {data})
                return res.data;
            }
        } catch (error) {
            return error.response.data
        }
    }

    async updateTransportationContract(contract_id, data) {
        try {
            if(data != ''){
                const res = await axios.put('/transportationcontract/update/'+contract_id, {data})
                return res.data;
            }
        } catch (error) {
            return error.response.data
        }
    }

    async deleteTransportationContract(contract_id) {
        try {
            if(contract_id != 0){
                const res = await axios.delete('/transportationcontract/delete/'+contract_id)
                return res.data;
            }
        } catch (error) {
            return error.response.data
        }
    }

    //TRANSPORTATION CONTRACT PERIOD
    async getTransportationContractPeriod(contract_id) {
        try {
            const res = await axios.get('/transportationcontractperiod/', {params: {contractid: contract_id}})
            return res.data;
        } catch (error) {
            return error.response.data
        }
    }

    async addTransportContractPeriod(data) {
        try {
            if(data != ''){
                const res = await axios.post('/transportationcontractperiod/add', {data})
                return res.data;
            }
        } catch (error) {
            return error.response.data
        }
    }

    async updateTransportContractPeriod(id, data) {
        try {
            if(data != ''){
                const res = await axios.put('/transportationcontractperiod/update/'+id, {data})
                return res.data;
            }
        } catch (error) {
            return error.response.data
        }
    }

    async deleteTransportContractPeriod(id) {
        try {
            if(id != 0){
                const res = await axios.delete('/transportationcontractperiod/delete/'+id)
                return res.data;
            }
        } catch (error) {
            return error.response.data
        }
    }

    //TRANSPORTATION RATE
    async getTransportationRate(period_id) {
        try {
            const res = await axios.get('/transportationrate', {params: {periodid: period_id}})
            return res.data;            
        } catch (error) {
            return error.response.data
        }
    }

    async addTransportationRate(data) {
        try {
            if(data != ''){
                const res = await axios.post('/transportationrate/add', {data})
                return res.data;
            }
        } catch (error) {
            return error.response.data
        }
    }

    async updateTransportationRate(id, data) {
        try {
            if(data != ''){
                const res = await axios.put('/transportationrate/update/'+id, {data})
                return res.data;
            }
        } catch (error) {
            return error.response.data
        }
    }

    async deleteTransportationRate(id) {
        try {
            if(id != 0){
                const res = await axios.delete('/transportationrate/delete/'+id)
                return res.data;
            }
        } catch (error) {
            return error.response.data
        }
    }

    //USE IN BOOKING FORM
    async getDriver(id) {
        try {
            if(id != 0){
                const res = await axios.get('/transportation/getdriver/', {params: {transportid: id}})
                return res.data;
            }
        } catch (error) {
            return error.response.data
        }
    }

    async getAllCompanyName() {
        try {
            const res = await axios.get('/transportation/getallcompany')
            return res.data;            
        } catch (error) {
            return error.response.data
        }
    }
}